/*
 * Public API Surface of quiz
 */

export * from './lib/quiz.service';
export * from './lib/quiz.component';
export * from './lib/quiz.module';
